import React from "react";
import LoadingScreen from "react-loading-screen";
import logo from "assets/img/logo/logo_aig_login-2.png";
import {
  Card,
  CardTitle,
  CardBody,
  CardImg,
  CardText,
  Row,
  Col,
  Button,
  Label,
  Input,
  FormGroup
} from "reactstrap";
import { Textbox, Checkbox } from "react-inputs-validation";
import "../../styles/estilos.css";
import Page from "components/Page";
import ValoresCotizacion from "./ValoresCotizacion";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { FetchDataProductosCarrito, FetchTotalesCabeceraCotizadores } from "../../redux/actions/ACarritoProductos";
import ListadoProductos from "./ListaProductosCotizacion/ListadoProductos";
import { FetchDescargarCotizacion, GuardarLeadFetch, recuperarDatosFacturacionFetch, listarColoresFetch, listarTerritoriosFetch, listarAccesoriosFetch, listarECivilesFetch, listarGenerosFetch, FetchDescargarCotizacionAuto } from "../../redux/actions/aCotizacion";
import { dataUsuario, setDataLeeds } from "../../redux/actions/aLogin";
import { ambienteAplicacion, urlGetRecompraConfirmacion, urlGuardarCodigoCuotas } from "../../constants/urls";
import Diferidos from "../Generales/Diferidos";
import { FetchDataBancosCuotas } from "../../redux/actions/APolizas";
import { apiGet } from "../../api";
import ListadoProductosComparador from "./ListaProductosCotizacion/ListadoProductosComparador";

class Cotizacion3Resumen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      placa: "",
      validate: false,
      hasPlacaError: true,
      chasis: this.props.datosCotizacion.datosPlaca === undefined ? "" : this.props.datosCotizacion.datosPlaca.chasis,
      codigoProductoEspecial: null,
      cargandoinicial: true,
      maximoMeses: 1,
      cuotasSeleccionadas: 1,
      bancoSeleccionado: null,
      email:''

    };
    this.onDescargar = this.onDescargar.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.onEnviar = this.onEnviar.bind(this);

  }

  toggleValidating(validate) {
    this.setState({ validate });
  }
  validateForm(e) {
    e.preventDefault();
    this.toggleValidating(true);
    const {
      hasContraseniaActualError,
      hasContraseniaNuevaError,
      hasConfirmacionError
    } = this.state;

    if (
      !hasContraseniaActualError ||
      !hasContraseniaNuevaError ||
      !hasConfirmacionError
    ) {
      this.handleOnClick();
    }
  }

  onEliminar = async () => {
    // e.preventDefault();
    // this.props.history.push({
    //   pathname: "/cotizacion",
    //   search: `?accion=eliminar`

    // });
    const queryParams = new URLSearchParams(this.props.location.search);
    const idCarrito = queryParams.get('id');
    //Agregado para mostrar los totales en la cabecera
    let datosJSON = {
      empresa: "AIGMETROPOLITANA",
      plataforma: "WEB",
      idCarrito: idCarrito
    }
    await this.props.datosFacturacion(datosJSON);
    //Cargar Totales de la cabecera
    if (this.props.dataFacturacion !== undefined && this.props.dataFacturacion !== "") {
      let param = {
        pathIcono: this.props.dataFacturacion.pathIconoTotalesCabecera ? this.props.dataFacturacion.pathIconoTotalesCabecera : "",
        totalItems: this.props.dataFacturacion.numItemsCarrito ? this.props.dataFacturacion.numItemsCarrito : "0",
        totalPrima: (this.props.dataFacturacion.carValoresTotales && this.props.dataFacturacion.carValoresTotales.primaTotal) ? this.props.dataFacturacion.carValoresTotales.primaTotal : "0.00",
        ramoCotizador: this.props.dataFacturacion.carDescripcionRamo ? this.props.dataFacturacion.carDescripcionRamo : "",
      }
      await this.props.actualizarTotalesCabecera(param);
    }
  }

  onDescargar1 = async () => {
    let datosJson = {
      empresa: "AIGMETROPOLITANA",
      plataforma: "WEB",
      accion: "descargar",
      correo: this.props.datosCotizacion.correo,
      idCarrito: this.props.datosCarrito.productosCarrito.idCarrito
    }
    if (this.state.codigoProductoEspecial == 'comparador') {
      await this.props.descargarCotizacionAuto(datosJson)
    } else {
      await this.props.descargarCotizacion(datosJson)
    }

    //let datosPago=this.props.datosCotizacion.datosDescarga;
    if (!this.props.datosCotizacion.generarCotizacionHasError) {
      //let newTab = window.open();
      //window.location.href = datosPago.urlPdf;
      //window.open(datosPago.urlPdf, "_blank")
    }
  }

  async onDescargar(event) {
    event.preventDefault()
    let datosJson = {
      empresa: "AIGMETROPOLITANA",
      plataforma: "WEB",
      accion: "descargar",
      correo: this.props.datosCotizacion.correo,
      idCarrito: this.props.datosCarrito.productosCarrito.idCarrito
    }
    await this.props.descargarCotizacion(datosJson)
    //let datosPago=this.props.datosCotizacion.datosDescarga;
    if (!this.props.datosCotizacion.generarCotizacionHasError) {
      //let newTab = window.open();
      //window.location.href = datosPago.urlPdf;
      //window.open(datosPago.urlPdf, "_blank")
    }
  }

  async onEnviar(event) {

    console.log('this.props.datosCotizacion.correo', this.props.datosCotizacion.correo)

    if (this.props.datosCotizacion.correo != "") {
      event.preventDefault()
      let datosJson = {
        empresa: "AIGMETROPOLITANA",
        plataforma: "WEB",
        accion: "enviar",
        correo: this.state.email,
        idCarrito: this.props.datosCarrito.productosCarrito.idCarrito
      }

      if (this.state.codigoProductoEspecial == 'comparador') {
        await this.props.descargarCotizacionAuto(datosJson)
      } else {
        await this.props.descargarCotizacion(datosJson)
      }


      //let datosPago=this.props.datosCotizacion.datosDescarga;
      if (!this.props.datosCotizacion.generarCotizacionHasError) {
        //let newTab = window.open();
        //window.location.href = datosPago.urlPdf;
        //window.open(datosPago.urlPdf, "_blank")
      }
    }



  }

  onClick = async () => {

    let idCarrito = this.props.datosCarrito.productosCarrito.idCarrito
    let urlEnviar = "https://";
    if (ambienteAplicacion === "local") {
      urlEnviar = "http://";
    }
    urlEnviar = urlEnviar + window.location.host + "/resumen-cotizacion?id=" + idCarrito + "&paso=datosfacturacion"
    const datosLead = {
      empresa: "AIGMETROPOLITANA",
      plataforma: "WEB",
      idcarrito: idCarrito,
      url: urlEnviar,
      paso: "",
      accion: "Solicitar Informacion del Contratante Facturación."
    }

    if (this.state.codigoProductoEspecial == 'vehiculosKilometrosPaquete') {
      await apiGet(`${urlGuardarCodigoCuotas}${idCarrito}&cuotas=${this.state.cuotasSeleccionadas}&codigoBanco=${this.state.bancoSeleccionado}`)

    }



    await this.props.actualizarLeadCotizacion(datosLead)
    this.props.history.push({
      pathname: "/confirmacion-cotizacion",
      //search: `?accion=agregar`      
    });
  }

  onClickAgregar = (e) => {

    var search = '?accion=agregar'

    if (this.state.codigoProductoEspecial == 'comparador') {
      search = '?accion=agregar&codigoProductoEspecial=comparador'
    }
    this.props.history.push({
      pathname: "/cotizacion",
      search: search

    });
  }
  redireccionar = () => {

    //console.log("URLOBTENIDA", window.location)
    const urlCompleta = window.location;
    const queryParams = new URLSearchParams(this.props.location.search);
    const idCarrito = queryParams.get('id');

    const objetoLeed = {
      path: urlCompleta.pathname,
      id: idCarrito
    }
    this.props.guardarDatosLeed(objetoLeed);


    localStorage.setItem("login", false);
    //this.props.limpiarDisclaimer();
    this.props.setDataUsuario(undefined);
    this.props.history.push({
      pathname: `/`
    });
  };
  async componentDidMount() {
    const queryParams = new URLSearchParams(this.props.location.search);
    const idCarrito = queryParams.get('id');
    const paso = queryParams.get('paso');
    let codigoProductoEspecial = queryParams.get("codigoProductoEspecial");
    if (codigoProductoEspecial != null) {

      console.log("codigoProductoEspecial", codigoProductoEspecial);
      this.setState({ codigoProductoEspecial: codigoProductoEspecial });
    } else {
      console.log("No codigoProductoEspecial");
    }

    console.log('this.state.codigoProductoEspecial',this.state.codigoProductoEspecial)

    this.props.listarColores(codigoProductoEspecial=='comparador'?codigoProductoEspecial:null);
    await this.props.listarTerritorios();
    await this.props.listarAccesorios();
    await this.props.listarEciviles();
    await this.props.listarGeneros();
    await this.props.listarCarrito(idCarrito);
    await this.props.listarBancosCuotas();
    await this.onDescargar1();

    const planSeleccionado = this.props.datosCarrito.productosCarrito.carProductos[0].datosCalculoScoring.plan
    const planes = this.props.datosCarrito.productosCarrito.carProductos[0].PlanesKmPaquete
    //const maximoMeses = this.state.codigoProductoEspecial == 'vehiculosKilometrosPaquete' ? planes.find(plan => plan.plan == planSeleccionado).vigenciaMeses.split(' ')[0] : 1
    console.log('datosCarrito: ', planSeleccionado)
    console.log('datosCarrito: ', planes)
    //console.log('datosCarrito: ', maximoMeses)
   /*  this.setState({
      maximoMeses: parseInt(maximoMeses)
    }) */
    //Agregado para mostrar los totales en la cabecera
    let datosJSON = {
      empresa: "AIGMETROPOLITANA",
      plataforma: "WEB",
      idCarrito: idCarrito
    }
    await this.props.datosFacturacion(datosJSON);
    //Cargar Totales de la cabecera
    if (this.props.dataFacturacion !== undefined && this.props.dataFacturacion !== "") {
      let param = {
        pathIcono: this.props.dataFacturacion.pathIconoTotalesCabecera ? this.props.dataFacturacion.pathIconoTotalesCabecera : "",
        totalItems: this.props.dataFacturacion.numItemsCarrito ? this.props.dataFacturacion.numItemsCarrito : "0",
        totalPrima: (this.props.dataFacturacion.carValoresTotales && this.props.dataFacturacion.carValoresTotales.primaTotal) ? this.props.dataFacturacion.carValoresTotales.primaTotal : "0.00",
        ramoCotizador: this.props.dataFacturacion.carDescripcionRamo ? this.props.dataFacturacion.carDescripcionRamo : "",
      }
      await this.props.actualizarTotalesCabecera(param);
    }
    if (this.props.datosUsuarios && this.props.datosUsuarios.cliCodigoCore !== undefined && this.props.datosCarrito.productosCarrito.carDatosAsesor && this.props.datosCarrito.productosCarrito.carDatosAsesor.codigoCore != undefined) {
      if (this.props.datosUsuarios.cliCodigoCore !== this.props.datosCarrito.productosCarrito.carDatosAsesor.codigoCore) {
        //console.log("validacion login ")
        //this.redireccionar()
        console.log('Nedd Log', this.props.datosUsuarios)
        /*this.props.history.push({
          pathname: "/recuperar-cotizacion-error",
          search: `?mensaje=usuarioincorrecto`
        });*/

      }
      else {
        if (paso !== "resumen") {
          this.props.history.push({
            pathname: "/confirmacion-cotizacion",
            //search: `?accion=agregar`      
          });
        }
      }
    }

    this.setState({
      cargandoinicial: false
    })
  }

  textosCargando() {
    if (this.props.datosCarrito.isLoading)
      return "Obteniendo datos de resumen..."
    if (this.props.datosCotizacion.generarCotizacionIsLoading)
      //return "Generando PDF de Cotización..."
      return "Obteniendo datos de resumen..."
    if (this.props.datosCotizacion.enviarCotizacionIsLoading)
      return "Enviando Cotización al Cliente..."


  }


  render() {
    const { validate, placa, chasis, cargandoinicial } = this.state;
    let { datosCotizacion, datosCarrito, paso } = this.props;
    let productosCarrito = {}
    //console.log("datoscarrito ", datosCarrito)
    if (datosCarrito !== undefined) {
      //console.log("datoscarrito !undefined", datosCarrito)
      productosCarrito = datosCarrito.productosCarrito.carProductos;
      //console.log("datoscarrito productosCarrito !", datosCarrito)
      if (productosCarrito === undefined) {
        productosCarrito = {
          carProductos: [],
          valorTotal: {}
        }
        //this.redireccionar()
      }
      else {
        //console.log("datoscarrito productosCarrito !undefined", datosCarrito)
        productosCarrito = datosCarrito.productosCarrito;
      }

    }
    else {

    }

    let mostrarAgregarItems = datosCarrito.productosCarrito.AgregarItems !== undefined ? datosCarrito.productosCarrito.AgregarItems : true;

    console.log('ver21', mostrarAgregarItems)

    return (
      <LoadingScreen
        loading={

          datosCarrito.isLoading || this.props.datosCotizacion.generarCotizacionIsLoading || this.props.datosCotizacion.enviarCotizacionIsLoading || cargandoinicial
        }
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text={this.textosCargando()}
      >
        <Page
          title={this.state.codigoProductoEspecial == "comparador" ? "AIG Auto" : "Cotización de vehículos"}
          breadcrumbs={[{ name: this.state.codigoProductoEspecial == "comparador" ? "AIG Auto" : "Cotización de vehículos", active: true }]}
        >
          <Row>
            <Col lg={8} md={12} sm={12} xs={12}>
              <div className="container-step">
                <div className="wrapper-step">
                  <div className="arrow-steps clearfix-step">
                    <div className="step"> {` 1. Cotización `} </div>
                    <div className="step current"> {` 2. Resumen `} </div>
                    <div className="step"> {` 3. Confirmación `} </div>
                    <div class="step"> {` 4. Forma de Pago `} </div>
                    <div class="step"> {` 5. Formulario de Vinculación `} </div>
                    <div class="step"> {` 6. Emisión `} </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          {mostrarAgregarItems && <Row>
            <Col lg={8} md={12} sm={12} xs={12}>
              {
                (this.state.codigoProductoEspecial === null ||
                  this.state.codigoProductoEspecial == 'comparador') &&
                <Button
                  className="btn btn-purple"
                  onClick={this.onClickAgregar}
                  style={{ display: "block", margin: "0 0 0 auto" }}
                >
                  <i className="fa fa-plus-circle" aria-hidden="true" /> AGREGAR
                  VEHÍCULO
                </Button>
              }
            </Col>
          </Row>
          }
          <Row>
            <Col lg={8} md={12} sm={12} xs={12} className="detalle-cotizacion-box">
              {datosCarrito.productosCarrito !== undefined &&
                productosCarrito.carProductos.map((carrito, index) => (

                  this.state.codigoProductoEspecial !== 'comparador' ?
                    <ListadoProductos codigoProductoEspecial={this.state.codigoProductoEspecial != null ? this.state.codigoProductoEspecial : null} ProductoEspecial={this.state.codigoProductoEspecial != null ? true : false} key={Math.random()} datosCotizacion={carrito} indice={index} origen={"resumen-cotizacion"} metodoEliminar={this.onEliminar}

                    />

                    : 
                    <ListadoProductosComparador codigoProductoEspecial={this.state.codigoProductoEspecial != null ? this.state.codigoProductoEspecial : null} ProductoEspecial={this.state.codigoProductoEspecial != null ? true : false} key={Math.random()} datosCotizacion={carrito} indice={index} origen={"resumen-cotizacion"} metodoEliminar={this.onEliminar}

                    />
                ))}

              {/*   {this.state.codigoProductoEspecial == 'vehiculosKilometrosPaquete' && this.props.datosBancosCuotas.bancosCuotas && this.props.datosBancosCuotas.bancosCuotas.length > 0 &&  <Diferidos
                datosBancos={this.props.datosBancosCuotas.bancosCuotas}
                maximoMeses={this.state.maximoMeses}
                setCuotasSeleccionadasPrincipal={value => this.setState({ cuotasSeleccionadas: value })}
                setBancoSeleccionadoPrincipal={value => this.setState({ bancoSeleccionado: value })}
              />} */}






            </Col>

            <Col lg={4} md={12} sm={12} xs={12} className="detalle-impuestos-box">
              <ValoresCotizacion email={this.state.email} setEmail={(email)=>{this.setState({email:email})}} ProductoEspecial={this.state.codigoProductoEspecial != null && this.state.codigoProductoEspecial ? false : true} formEditado={false} paso={"resumen-cotizacion"} metodo={this.onClick} metodoDescargar={this.onDescargar} metodoEnviar={this.onEnviar} valorTotal={productosCarrito.valorTotal} codeProductoEspecial={this.state.codigoProductoEspecial} />
            </Col>
          </Row>
        </Page>
      </LoadingScreen>
    );
  }
}




const mapStateToProps = state => ({
  datosCotizacion: state.datosCotizacion,
  datosCarrito: state.dataProductoCarrito,
  datosUsuarios: state.datosUsuarios.dataUsuario,
  dataFacturacion: state.dataFacturacion.datosFacturacion,
  datosBancosCuotas: state.dataBancosCuotas,
});

const mapDispatchToProps = dispatch => {
  return {
    listarCarrito: (idCarrito) => dispatch(FetchDataProductosCarrito(idCarrito)),
    descargarCotizacion: (datos) => dispatch(FetchDescargarCotizacion(datos)),
    descargarCotizacionAuto: (datos) => dispatch(FetchDescargarCotizacionAuto(datos)),
    listarBancosCuotas: () => dispatch(FetchDataBancosCuotas()),
    setDataUsuario: data => dispatch(dataUsuario(data)),
    guardarDatosLeed: (data) => dispatch(setDataLeeds(data)),
    actualizarLeadCotizacion: (data) => dispatch(GuardarLeadFetch(data)),
    datosFacturacion: (data) => dispatch(recuperarDatosFacturacionFetch(data)),
    actualizarTotalesCabecera: (param) => dispatch(FetchTotalesCabeceraCotizadores(param)),
    listarColores: (productoEspecial) => dispatch(listarColoresFetch(productoEspecial)),
    istarBancosCuotas: () => dispatch(FetchDataBancosCuotas()),
    listarTerritorios: () => dispatch(listarTerritoriosFetch()),
    listarAccesorios: () => dispatch(listarAccesoriosFetch()),
    listarEciviles: () => dispatch(listarECivilesFetch()),
    listarGeneros: () => dispatch(listarGenerosFetch()),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Cotizacion3Resumen)
);
